module.exports = __webpack_public_path__ + "static/media/green_download_icon.f91f0e78.png";